import React from 'react';
import { Modal } from './Modal';

interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function PrivacyPolicyModal({ isOpen, onClose }: PrivacyPolicyModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Polityka prywatności serwisu liczymy.nauczniaczek.pl"
    >
      <div className="prose max-w-none space-y-6">
        <section>
          <h3 className="text-xl font-bold">I. Informacje ogólne</h3>
          <div className="space-y-2">
            <p className="font-semibold">Administrator danych osobowych:</p>
            <p>JG Invest PSA z siedzibą w Oświęcimiu</p>
            <p>ul. Jana Matejki</p>
            <p>NIP: 5492463888</p>
            <p>KRS: 0000915798</p>
            <p>REGON: 389702924</p>
            
            <p className="font-semibold">Kontakt w sprawach ochrony danych:</p>
            <p>Email: iod@nauczniaczek.pl</p>
            <p>Adres korespondencyjny: ul. Jana Matejki, Oświęcim</p>
            
            <p className="font-semibold">Inspektor Ochrony Danych:</p>
            <p>Email: iod@nauczniaczek.pl</p>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">II. Ochrona danych osobowych dzieci</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Szczególne zasady ochrony:</p>
              <ul className="list-disc pl-5">
                <li>Wymagana zgoda rodzica/opiekuna prawnego dla użytkowników poniżej 13 roku życia</li>
                <li>Weryfikacja wieku podczas rejestracji</li>
                <li>Minimalizacja zbieranych danych</li>
                <li>Zabezpieczenia techniczne i organizacyjne dostosowane do ochrony danych dzieci</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Zakres zbieranych danych:</p>
              <p className="font-semibold mt-2">a) Dane dziecka:</p>
              <ul className="list-disc pl-5">
                <li>Wiek</li>
                <li>Postępy w nauce</li>
                <li>Statystyki użytkowania</li>
                <li>Nick/pseudonim</li>
              </ul>

              <p className="font-semibold mt-2">b) Dane opiekuna:</p>
              <ul className="list-disc pl-5">
                <li>Adres email</li>
                <li>Dane do faktury (opcjonalnie)</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">III. Cele i podstawy przetwarzania</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Realizacja usług edukacyjnych (Art. 6 ust. 1 lit. b RODO):</p>
              <ul className="list-disc pl-5">
                <li>Prowadzenie konta</li>
                <li>Zapisywanie postępów</li>
                <li>Dostosowanie poziomu trudności</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Zgoda opiekuna prawnego (Art. 6 ust. 1 lit. a RODO):</p>
              <ul className="list-disc pl-5">
                <li>Marketing bezpośredni</li>
                <li>Newsletter edukacyjny</li>
                <li>Analiza postępów dziecka</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Prawnie uzasadnione interesy (Art. 6 ust. 1 lit. f RODO):</p>
              <ul className="list-disc pl-5">
                <li>Bezpieczeństwo serwisu</li>
                <li>Analiza statystyczna</li>
                <li>Doskonalenie funkcjonalności</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">IV. Pliki cookies i inne technologie</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Rodzaje wykorzystywanych plików cookies:</p>
              
              <p className="font-semibold mt-2">a) Niezbędne cookies:</p>
              <ul className="list-disc pl-5">
                <li>Utrzymanie sesji użytkownika</li>
                <li>Zapamiętanie ustawień</li>
                <li>Zapewnienie bezpieczeństwa</li>
              </ul>
              <p className="text-sm text-gray-600">Podstawa: Prawnie uzasadniony interes (Art. 6 ust. 1 lit. f RODO)</p>

              <p className="font-semibold mt-2">b) Funkcjonalne cookies:</p>
              <ul className="list-disc pl-5">
                <li>Zapamiętywanie preferencji</li>
                <li>Personalizacja treści</li>
                <li>Zapisywanie postępów</li>
              </ul>
              <p className="text-sm text-gray-600">Podstawa: Zgoda opiekuna (Art. 6 ust. 1 lit. a RODO)</p>

              <p className="font-semibold mt-2">c) Analityczne cookies:</p>
              <ul className="list-disc pl-5">
                <li>Badanie sposobu korzystania z serwisu</li>
                <li>Poprawa funkcjonalności</li>
                <li>Statystyki użytkowania</li>
              </ul>
              <p className="text-sm text-gray-600">Podstawa: Zgoda opiekuna (Art. 6 ust. 1 lit. a RODO)</p>
            </div>

            <div>
              <p className="font-semibold">Zarządzanie cookies:</p>
              <ul className="list-disc pl-5">
                <li>Możliwość zmiany ustawień w przeglądarce</li>
                <li>Panel preferencji w serwisie</li>
                <li>Wycofanie zgody w dowolnym momencie</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">V. Narzędzia analityczne</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Google Analytics:</p>
              <ul className="list-disc pl-5">
                <li>Wykorzystujemy Google Analytics 4 (GA4) do analizy ruchu w serwisie</li>
                <li>Dane są zbierane w sposób zanonimizowany</li>
                <li>Włączona jest funkcja anonimizacji adresów IP</li>
                <li>Dane są przechowywane na serwerach Google w UE</li>
                <li>Okres przechowywania danych w GA4: 14 miesięcy</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Google Tag Manager (GTM):</p>
              <ul className="list-disc pl-5">
                <li>Używamy GTM do zarządzania skryptami i tagami w serwisie</li>
                <li>GTM nie zbiera bezpośrednio danych osobowych</li>
                <li>Poprzez GTM implementowane są:
                  <ul className="list-disc pl-5 mt-2">
                    <li>Google Analytics</li>
                    <li>Skrypty niezbędne do działania serwisu</li>
                    <li>Znaczniki konwersji</li>
                  </ul>
                </li>
                <li>Wszystkie tagi są weryfikowane pod kątem bezpieczeństwa</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">VI. Prawa użytkowników i opiekunów</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Prawa podstawowe:</p>
              <ul className="list-disc pl-5">
                <li>Dostęp do danych</li>
                <li>Sprostowanie danych</li>
                <li>Usunięcie danych</li>
                <li>Ograniczenie przetwarzania</li>
                <li>Przenoszenie danych</li>
                <li>Sprzeciw wobec przetwarzania</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Prawa szczególne opiekunów:</p>
              <ul className="list-disc pl-5">
                <li>Wgląd w dane dziecka</li>
                <li>Modyfikacja ustawień prywatności</li>
                <li>Kontrola aktywności dziecka</li>
                <li>Usunięcie konta dziecka</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">VII. Bezpieczeństwo danych</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Środki techniczne:</p>
              <ul className="list-disc pl-5">
                <li>Szyfrowanie SSL/TLS</li>
                <li>Bezpieczne hasła</li>
                <li>Kopie zapasowe</li>
                <li>Monitoring bezpieczeństwa</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Środki organizacyjne:</p>
              <ul className="list-disc pl-5">
                <li>Polityka czystego biurka</li>
                <li>Szkolenia pracowników</li>
                <li>Procedury bezpieczeństwa</li>
                <li>Ograniczony dostęp do danych</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">VIII. Udostępnianie danych</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Odbiorcy danych:</p>
              <ul className="list-disc pl-5">
                <li>Dostawcy usług hostingowych</li>
                <li>Dostawcy narzędzi analitycznych</li>
                <li>Podmioty świadczące usługi wsparcia technicznego</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Przekazywanie danych poza EOG:</p>
              <ul className="list-disc pl-5">
                <li>Wyłącznie do podmiotów zapewniających odpowiedni poziom ochrony</li>
                <li>Na podstawie standardowych klauzul umownych</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">IX. Okres przechowywania danych</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Dane konta:</p>
              <ul className="list-disc pl-5">
                <li>Przez okres aktywności konta</li>
                <li>30 dni po usunięciu konta (backup)</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Dane analityczne:</p>
              <ul className="list-disc pl-5">
                <li>Do 14 miesięcy w Google Analytics</li>
                <li>W formie zanonimizowanej do 24 miesięcy</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">X. Zmiany polityki prywatności</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Sposób informowania:</p>
              <ul className="list-disc pl-5">
                <li>Powiadomienie email</li>
                <li>Komunikat w serwisie</li>
                <li>14-dniowy okres na akceptację zmian</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">XI. Kontakt i zgłaszanie naruszeń</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Kontakt w sprawach prywatności:</p>
              <ul className="list-disc pl-5">
                <li>Email: privacy@nauczniaczek.pl</li>
                <li>Formularz kontaktowy w serwisie</li>
                <li>Adres korespondencyjny</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Zgłaszanie naruszeń:</p>
              <ul className="list-disc pl-5">
                <li>Dedykowany adres: security@nauczniaczek.pl</li>
                <li>Czas reakcji: do 24 godzin</li>
                <li>Procedura powiadamiania o naruszeniach</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">XII. Wersja dla dzieci</h3>
          <div className="bg-blue-50 p-4 rounded-lg space-y-4">
            <p className="text-lg">Cześć! 👋</p>
            <p>To jest opis tego, jak dbamy o Twoją prywatność w Nauczniaczku:</p>

            <div>
              <p className="font-semibold">Co o Tobie wiemy?</p>
              <ul className="list-disc pl-5">
                <li>Tylko tyle, ile potrzeba do nauki</li>
                <li>Twój wiek i postępy w nauce</li>
                <li>Twój nick w grze</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Co robimy z tymi informacjami?</p>
              <ul className="list-disc pl-5">
                <li>Pomagamy Ci się uczyć</li>
                <li>Pamiętamy Twoje osiągnięcia</li>
                <li>Pokazujemy zadania na Twoim poziomie</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Kto może zobaczyć Twoje informacje?</p>
              <ul className="list-disc pl-5">
                <li>Twoi rodzice/opiekunowie</li>
                <li>Nauczyciele w Nauczniaczku</li>
                <li>Nikt inny!</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Twoje prawa:</p>
              <ul className="list-disc pl-5">
                <li>Możesz poprosić rodziców o zobaczenie swoich danych</li>
                <li>Możesz poprosić o zmianę lub usunięcie danych</li>
                <li>Możesz przestać korzystać z Nauczniaczka kiedy chcesz</li>
              </ul>
            </div>
          </div>
        </section>

        <p className="text-sm text-gray-500 mt-8">Data aktualizacji: 06.02.2025</p>
      </div>
    </Modal>
  );
}